// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-edit-icon[data-v-3a63b9f9] {\n  margin: auto 5px auto 10px;\n}\n.cursor-pointer[data-v-3a63b9f9] {\n  cursor: pointer !important;\n}\n.file-edit-group[data-v-3a63b9f9] {\n  border: 1px solid var(--border-medium);\n  cursor: pointer !important;\n}\n.file-group[data-v-3a63b9f9] {\n  border: 1px solid var(--border-medium);\n}\n", ""]);
// Exports
module.exports = exports;
